<template>
  <div id="result">
    <top></top>
    <div class="main">
      <div class="content">
        <titleBackground :title="'活动申报信息'"></titleBackground>
        <div class="result-content">
          <div>
            <p>单位名称</p>
            <p>{{ declarationResult.base_company_cn }}</p>
          </div>
          <div>
            <p>单位地址</p>
            <p>{{ declarationResult.base_detailed_address }}</p>
          </div>
          <div>
            <p>营业执照上传</p>
            <div class="result-content-image">
              <singleImageUpload
                @handlePreviewImage="handlePreviewImage"
                :only_preview="true"
                :imageSrc="declarationResult.gen_business_license"
              ></singleImageUpload>
            </div>
          </div>
          <div>
            <p>单位简介</p>
            <p>{{ declarationResult.base_introduce }}</p>
          </div>
          <div>
            <p>简介上传</p>
            <div class="result-content-file">
              <i class="el-icon-paperclip"></i>
              <p
                @click="
                  openCompantIntroduction(declarationResult.base_introduce_file)
                "
              >
                企业简介
              </p>
            </div>
          </div>
          <div></div>
          <div>
            <p>项目联系人</p>
            <p>{{ declarationResult.base_contacts }}</p>
          </div>
          <div>
            <p>部门及职务</p>
            <p>{{ declarationResult.base_position }}</p>
          </div>
          <div>
            <p>电话</p>
            <p>{{ declarationResult.base_mobile }}</p>
          </div>
          <div>
            <p>邮箱</p>
            <p>{{ declarationResult.base_email }}</p>
          </div>
          <div>
            <p>合作意向说明</p>
            <p>{{ declarationResult.intent_info }}</p>
          </div>
          <div>
            <p>申报活动名称</p>
            <p>{{ declarationResult.brand_name_cn }}</p>
          </div>
        </div>
        <div class="result_button">
          <div class="declare_borderButton" @click="back">返回</div>
          <div class="declare_fillButton" @click="re_edit">重新编辑</div>
        </div>
      </div>
    </div>
    <maskLayer
      :show="maskLayerShow"
      :type="maskLayerType"
      :imgSrc="declarationResult.gen_business_license"
      @handleCancelPreviewImage="handleCancelPreviewImage"
    ></maskLayer>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import titleBackground from "../dataReview/json/titleBackground.vue";
import singleImageUpload from "../../components/singleImageUpload.vue";
import maskLayer from "../../components/maskLayer.vue";
import { getOtherActivityDeclarationResult } from "../../api/api";
export default {
  name: "declarationResult",
  components: { top, titleBackground, singleImageUpload, maskLayer },
  data() {
    return {
      maskLayerShow: false,
      maskLayerType: "",
      declarationResult: {},
    };
  },
  created() {
    this.getOtherDeclarationResult();
  },
  methods: {
    async getOtherDeclarationResult() {
      const res = await getOtherActivityDeclarationResult();
      console.log(res);
      if (res.code == 1) {
        this.declarationResult = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    openCompantIntroduction(src) {
      window.open(src, "_blank");
    },
    handlePreviewImage() {
      this.maskLayerShow = true;
      this.maskLayerType = "preview";
    },
    handleCancelPreviewImage() {
      this.maskLayerShow = false;
      this.maskLayerType = "";
    },
    re_edit() {
      this.$confirm(
        "重新编辑会回到审核中状态，请问您是否确定要重新编辑?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$router.push({
            path: "/otherDeclaration",
          });
        })
        .catch(() => {});
    },
    back() {
      this.$router.push({
        path: "/home",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.result-content {
  margin-top: 40px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  > div {
    width: 28%;
    margin-right: 2%;
    margin-bottom: 40px;
    > p:first-child {
      font-size: 16px;
      color: #666;
      margin-bottom: 8px;
    }
    > p:last-child {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      box-sizing: border-box;
      padding-right: 30px;
    }
    .result-content-image {
      height: 160px;
    }
    .result-content-file {
      display: flex;
      align-items: center;
      color: #333;
      i {
        margin-right: 4px;
      }
      p {
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
}
.result_button {
  display: flex;
  width: 267px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  justify-content: space-between;
  align-items: center;
}
</style>